import ExportJsonExcel from 'js-export-excel';

class ExportPriceListExcel {
    exportExcel(planServices, priceList) {
        console.log({planServices}, {priceList});
        let option = {};  // la opción representa el archivo de Excel
        let sheetData = [];
        let appointmentOpportunityData = this.saveBoxes(planServices);

        console.log(sheetData);

        option.fileName = `Lista de Precios ${priceList.nombre}`;  // nombre del archivo Excel (Maximo 31 caracteres)
        option.datas = [
            {
                sheetName: `${priceList.nombre}`,  // nombre de la página de hoja en el archivo de Excel
                /*  sheetFilter: this.getFilterAndHeader(),
                 sheetHeader: this.getFilterAndHeader(), */
                //columnWidths: [20, 20],
                sheetData: appointmentOpportunityData.data  // Fuente de datos en archivo Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel

    }

    getFilterAndHeader() {
        let headers = {
            '1': "ID SERVICIO SAC",
            '2': "CUPS",
            '3': "NOMBRE SERVICIO",
            '4': "COSTO"
        }
        return headers;
    }

    saveBoxes(planServices) {

        let dataTable = [];
        let casillasVacias = this.generarCasillasVacias();
        //Titulos
        let CasillasTitulos = this.getFilterAndHeader();
        dataTable.push(CasillasTitulos);
        if(Array.isArray(planServices)){
            planServices.forEach(serv => {
                let infoDetallada = this.generarInformacionDetallada(serv);
                dataTable.push(infoDetallada);
            } )
        }
        dataTable.push(casillasVacias);

        let sheet = {
            data: dataTable
        }
        return sheet;
    }

    generarInformacionDetallada(data) {
        let casillas = {
            '1': data.id_servicio ?? "",
            '2': data.codigo ?? "",
            '3': data.servicios ?? "",
            '4': data.costo ?? ""
        }
        return casillas;
    }

    generarCasillasVacias() {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': ""
        }
        return casillas;
    }

}

export default new ExportPriceListExcel();